import React from 'react';

import { getColour } from '../../utils/functions';

export default function ListItem(props) {
  const { FLAG, NAME, YEAR, STATUS } = props;
  // console.log('props ', props);

  const colour = getColour(STATUS);
  const src = `images/${FLAG}`;

  const flagWrapStyle = {
    backgroundColor: colour,
  };

  const percWidth =
    STATUS === 'Achieved (self-declared)'
      ? ((parseFloat(2021) - 2020) / 55) * 100
      : ((parseFloat(YEAR) - 2020) / 55) * 100;

  const barStyle = {
    backgroundColor: colour,
    width: `${percWidth}%`,
    height: '40px',
  };

  const nameWrapStyle = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderImage: `repeating-linear-gradient(90deg, #fff, ${colour} 30px) 60`,
  };

  const nameStyle = {
    color: colour,
  };

  const triStyle = {
    position: 'absolute',
    top: 0,
    left: `${percWidth}%`,
    borderLeft: `10px solid ${colour}`,
  };

  const yearStyle = {
    color: STATUS === 'Achieved (self-declared)' ? colour : '#fff',
    left:
      STATUS === 'Achieved (self-declared)'
        ? '26px'
        : `calc(${percWidth}% - 40px)`,
    textAlign: STATUS === 'Achieved (self-declared)' ? 'left' : 'right',
  };

  function getYear(year) {
    if (STATUS !== 'Achieved (self-declared)') {
      return year;
    }
    return '';
  }

  return (
    <section className="list-item-wrap">
      <div className="name-wrap" style={nameWrapStyle}>
        <p style={nameStyle}>{NAME}</p>
      </div>
      <div className="flag-wrap" style={flagWrapStyle}>
        <img src={src} width="100" height="100" alt="flag" />
      </div>
      <div className="bar-wrap">
        <div className="bar" style={barStyle} />
        <div className="triangle" style={triStyle} />
        <div className="year" style={yearStyle}>
          {getYear(YEAR)}
        </div>
      </div>
    </section>
  );
}
